import { GetServerSideProps } from 'next'
import { Language } from '../config/Languages'
import Home from '../src/components/HelpPage/Home'
import axios from 'axios'
import { Tree } from 'src/types'
import { PROXY_URL } from 'src/constants/Constants'
import { env } from 'src/env.mjs'

export async function getTree(lang: Language) {
  const contentViewIdKey = `NEXT_PUBLIC_CONTENT_VIEW_ID_${lang.toUpperCase()}`
  const url = `${env.NEXT_PUBLIC_SABIO_BASE_URL}${env[contentViewIdKey]}/tree`
  const { data } = await axios.post<Tree>(PROXY_URL, {
    url,
    method: 'get',
    params: {
      lang,
    },
  })

  return data
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const tree = await getTree(context.locale as Language)
  return {
    props: {
      tree,
    },
  }
}

export default Home
